import { Field } from "@progress/kendo-react-form"
import styles from '../../../styles/estrategiaAdaptacao/EstrategiaAdaptacao.module.scss';
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { coordenadasPoligono, entidades, fillVusAsync, getEaRegistoAnalise, handleGenericError, post, vus } from "../../../services/utils";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { filterBy } from "@progress/kendo-data-query";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import FieldsetCombosLocalizacao from "../../localizacao/FieldsetCombosLocalizacao";
import ValidatedIdentificacaoCheckbox from "./ValidationComponentes/ValidatedIdentificacaoCheckbox";
import { requiredFieldValidator } from "../../../validations/ocorrencia";
import useVisibleColumns, { Key } from "../../../hooks/useVIsibleColumns";
import SessionStorageService from "../../../services/SessionStorageService";
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent, GridToolbar } from "@progress/kendo-react-grid";
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import { ResultadoValorUsoDoSoloCommandGridCell } from "../../usosdosolo/ResultadoValorUsoDoSoloCommandGridCell";
import { useValorUsoDoSoloStore } from "../../../stores/valorUsoDoSolo";
import DetalheValorUsoDoSolo from "../../usosdosolo/DetalheValorUsoDoSolo";
import { Dialog } from '@progress/kendo-react-dialogs'
import VisualizadorColunas from "../../Generico/VisualizadorColunas ";
import { GET_EA_VALOR_USO_DE_SOLO_BY_CUSTOM_FILTERS, GET_VALOR_USO_DE_SOLO_BY_CUSTOM_FILTERS } from "../../../utils/constants";
import { useCommonStore } from "../../../stores/common";
import html2canvas from "html2canvas";
import { process } from '@progress/kendo-data-query';
import ReactGA from 'react-ga4';
import CustomGridCell from '../../ocorrencia/CustomGridCell';

type IProps = {
    idForm: number
    initialValuesForm?: any
    viewMode?: boolean
    colunasVisiveis?: any
    onChange?: any
    initialized?: any
    isMobile?: boolean
}

type ValorTituloUsoDoSolo = {
    id: number;
    vus: string;
    tipo: string;
    valor: string;
}

type PageState = {
    skip: number
    take: number
}

const initialDataState: PageState = { skip: 0, take: 10 }


const VusEstrategiaAdaptacao = forwardRef(({
    idForm, initialValuesForm, viewMode, colunasVisiveis, onChange, initialized, isMobile
}: IProps, ref: React.Ref<any>) => {

    const [vus, setVus] = useState<ValorTituloUsoDoSolo[]>([])
    const [anoReferencia, setAnoReferencia] = useState<any>()
    const [valorTotalFS50Anos, setValorTotalFS50Anos] = useState<number>()
    const [valorTotalFS100Anos, setValorTotalFS100Anos] = useState<number>()
    
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false)

    const [page, setPage] = useState<PageState>(initialDataState)
    const [pageSizeValue, setPageSizeValue] = useState<number | string | undefined>()

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/VusEstrategiaAdaptacao" });
    }, []);


    useEffect(() => {
        SessionStorageService.setItem("dataGridValoresUsosDoSolo", initialValuesForm?.vus);

        loadInterface();
        initialized(idForm);
        onChange()
    }, []);

    useEffect(() => {
        SessionStorageService.setItem("dataGridValoresUsosDoSolo", initialValuesForm?.vus);
        loadInterface();
        onChange()
    }, [initialValuesForm]);

    /**
     * Define exposed component functions
     **/
    useImperativeHandle(ref, () => ({
        getValues: () => initialValuesForm?.vus ?? [],
        isValid: () => true,
        showInvalidMessage: () => { return; }
    }));


    const loadInterface = () => {

        postMessage({ type: 'showLoader' }, '*')

        try {

            if (initialValuesForm?.vus.length > 0) {
                const iframe: any = document.getElementById('iframeGeoPortal')

                initialValuesForm?.vus.map((vus: any) => {
                    if (!vus.id) {
                        vus.id = vus.id_no_vus_table;
                    }
                });

                const listPontos = initialValuesForm?.vus.filter((vus: any) => vus.tipo_geom_vus == 'ponto');
                const listPoligonos = initialValuesForm?.vus.filter((vus: any) => vus.tipo_geom_vus == 'poligono');

                const columns = colunasVisiveis?.columns?.filter((x: { show: any }) => x.show).map((option: { field: any; title: any }) => ({
                    field: option.field,
                    title: option.title
                }));

                iframe.contentWindow?.postMessage(
                    {
                        type: 'SiarlDefineExtraLayerTooltipColumns', value: {
                            layer: 'Siarl:usVusPoligono', columns: columns
                        }
                    }, '*'
                );

                iframe.contentWindow?.postMessage(
                    {
                        type: 'SiarlDefineExtraLayerTooltipColumns', value: {
                            layer: 'Siarl:usVusPonto', columns: columns
                        }
                    }, '*'
                );

                if (listPoligonos.length > 0) {
                    const listIdPolg = listPoligonos.map((vus: any) => vus.id_no_vus_table)
                    iframe.contentWindow?.postMessage({ type: 'SiarlUsVusPoligonoSearch', value: { ids: listIdPolg, result: listPoligonos } }, '*')
                }
                if (listPontos.length > 0) {
                    const listIdPonto = listPontos.map((vus: any) => vus.id_no_vus_table);
                    iframe.contentWindow?.postMessage({ type: 'SiarlUsVusPontoSearch', value: { ids: listIdPonto, result: listPontos } }, '*')
                }
            }

            setVus(initialValuesForm?.vus);
            setAnoReferencia(initialValuesForm?.anoReferencia);
            setValorTotalFS50Anos(initialValuesForm?.valorTotalFS50Anos);
            setValorTotalFS100Anos(initialValuesForm?.valorTotalFS100Anos);
       
            SessionStorageService.setItem("analiseResultado", initialValuesForm);
            saveScreenById("imgsVus")

        } catch (error) {
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')
        } finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const closeModal = () => { setShowDetailModal(!showDetailModal) }

    const styleCells = { 'paddingLeft': '5px', 'paddingRight': '5px', 'textAlign': 'center' }


    const BCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ ...props.style, ...styleCells }}>
                Ano de análise: <br /><span>{anoReferencia ?? '----'}</span>
            </td>
        );
    };

    const CCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ ...props.style, ...styleCells }}>
                Nivel 1: <br /><span>{getFormatedEurNumber(valorTotalFS50Anos || 0)}</span>
            </td>
        );
    };

    const DCell = (props: any) => {
        return (
            <td colSpan={props.colSpan} style={{ ...props.style, ...styleCells }}>
                Nivel 2: <br /><span>{getFormatedEurNumber(valorTotalFS100Anos || 0)}</span>
            </td>
        );
    };

    const getFormatedEurNumber = (value: any) => {
        return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value);
    }


    const handlePageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;
        const take = targetEvent.value === "All" ? vus.length : event.page.take;

        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take
        });
    };

    const selectValorUsoDoSolo = useValorUsoDoSoloStore((state) => state.selectValorUsoDoSoloResult)

    /*const handleInfoClickById = (valorUsoDoSolo: Record<string, any>) => async () => {
        selectValorUsoDoSolo(valorUsoDoSolo)
    }*/

    const restoreView = useCommonStore(state => state.restoreView)

    const getGpMessagePrefix = (item: Record<string, any>) => {
        return item.tipo_geom_vus == 'poligono' ? 'SiarlUsVusPoligono' : 'SiarlUsVusPonto';
    }

    const handleLocationClickById = (item: Record<string, any>) => () => {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const id = item.id_no_vus_table;
        const service = `${getGpMessagePrefix(item)}Center`

        iframe.contentWindow?.postMessage({ type: service, value: [id] }, '*')

        restoreView();
    }

    const CommandCell = (props: GridCellProps) => (
        <ResultadoValorUsoDoSoloCommandGridCell
            {...props}
            onMapCenter={handleLocationClickById}
            onLocationMouseEnter={handleRowMouseEnterById}
            onLocationMouseLeave={handleRowMouseLeaveById}
        />
    )

    const getCurrentColumn = (column: string) => {
        switch (column) {
            case "B":
                return BCell;
            case "C":
                return CCell;
            case "D":
                return DCell;
            default:
        }
    }

    const saveScreenById = async (key: string) => {
        let mapImage = ''

        if (!window.location.href.includes('localhost')) {
            const mapIframe = document.querySelector(
                '#iframeGeoPortal'
            ) as HTMLIFrameElement

            const mapIframeInnerContent =
                mapIframe.contentWindow?.document.querySelector(
                    'section.content'
                ) as HTMLElement

            const generatedImage = await html2canvas(mapIframeInnerContent)
            mapImage = generatedImage.toDataURL()
            SessionStorageService.setItem(key, JSON.stringify({
                img_mapa_vus: mapImage
            }))
        }
    }

    const handleRowMouseEnterById = (item: any) => {
        const id = item.id_no_vus_table ?? null;

        if (id) {
            const iframe: any = document.getElementById('iframeGeoPortal');
            const service = `${getGpMessagePrefix(item)}Highlight`

            iframe.contentWindow?.postMessage({ type: service, value: [id] }, '*')
        }
    }

    const handleRowMouseLeaveById = (item: any) => {
        const id = item.id_no_vus_table ?? null;

        if (id) {
            const iframe: any = document.getElementById('iframeGeoPortal');
            const service = `${getGpMessagePrefix(item)}HighlightRemove`

            iframe.contentWindow?.postMessage({ type: service, value: [id] }, '*')
        }
    }


    const nivelCell = (props: any) => (
        <td
            style={isMobile ? {} : { textAlign: 'center' }}
            onMouseEnter={() => handleRowMouseEnterById(props.dataItem)} 
            onMouseLeave={() => handleRowMouseLeaveById(props.dataItem)}>
            {props.dataItem[props.field] ? `Nivel ${props.dataItem[props.field]}` : ''}
        </td>
    )

    const responsiveSummaryCell = () => {

        const styleColumn:any = { textAlign: 'center', flex: 1, padding: '10px', boxSizing: 'border-box' };
        const styleTitle = { fontWeight: 'bold' };

        return (
            <div style={{ display: 'flex', marginTop: '20px' }}>
                <div style={styleColumn}><span style={styleTitle}>Ano de análise:</span> <br/><span>{anoReferencia ?? '----'}</span></div>
                <div style={styleColumn}><span style={styleTitle}>Nivel 1: </span><br/><span>{getFormatedEurNumber(valorTotalFS50Anos || 0)}</span></div>
                <div style={styleColumn}><span style={styleTitle}>Nivel 2: </span><br/><span>{getFormatedEurNumber(valorTotalFS100Anos || 0)}</span></div>
            </div>
        )
    }

    const CustomCell = (props: GridCellProps) => (
        <CustomGridCell
            {...props}
            onMouseEnter={handleRowMouseEnterById}
            onMouseLeave={handleRowMouseLeaveById}
        />
    )

    const getCell = (cellName: string) => {
        switch (cellName) {
            case "nivelCell":
                return nivelCell;
            default:
        }
        return null
    }

    return (
        <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
            <Grid
                style={isMobile ? { paddingBottom: '10px !important' } : {}}
                data={vus?.slice(page.skip, page.take + page.skip).map((vus: any) => (
                    {
                        ...vus,
                        valor: new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(vus.valor)
                    }
                ))}
                cells={{ data: CustomCell }}
                onPageChange={handlePageChange}
                pageable={{
                    buttonCount: 5,
                    info: true,
                    type: 'numeric',
                    pageSizes: true,
                    previousNext: true,
                }}
                skip={page.skip}
                take={page.take}
                sort={[]}
                group={[]}
                sortable={true}
                total={vus?.length}
            >
                <GridColumn cell={CommandCell} width={50} />
                {colunasVisiveis?.columns?.map((column: any, i: number) => {
                    return (
                        column.show && (
                            <GridColumn key={i} field={column.field} width={column.width} title={column.title} className={column.className} cell={column.cell ? getCell(column.cell) : column.cell} headerCell={column.headerCell} footerCell={getCurrentColumn(column.footerCell)} />
                        )
                    );
                })}
            </Grid>
            {
                showDetailModal ?
                    <Dialog width={950} height={550} onClose={closeModal} title={"Detalhes"}>
                        <DetalheValorUsoDoSolo />
                    </Dialog >
                    : <></>
            }
            {isMobile ? responsiveSummaryCell() : <></>}
        </div>
    );
});

export default VusEstrategiaAdaptacao;